import React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { TouchBackend } from 'react-dnd-touch-backend';
import { MultiBackend } from 'react-dnd-multi-backend';
import { createRoot } from 'react-dom/client';
import config from './config.js';
import App from './App.jsx';
import Modal from 'react-modal';
import { bootstrapLocalization } from './locales/bootstrap.js';

import './styles/IntroPage.css';  // Import global styles

const resolveTheme = () => {
  const validThemes = ['songshake', 'banana-split', 'black-forest'];
  const storedTheme = sessionStorage.getItem('theme');
  return validThemes.includes(storedTheme) ? storedTheme : config.defaultTheme;
};

document.documentElement.setAttribute('data-theme', resolveTheme());

// Locale before the first paint, like the theme: <html lang dir> for the
// resolved locale and its catalog ready, so the shell never flashes in
// English / left-to-right on the way to the listener's language (ENG-378).
bootstrapLocalization();

// Multi-backend configuration for drag and drop
// HTML5Backend for desktop/mouse interactions, TouchBackend for mobile/touch
const backendOptions = {
  backends: [
    {
      id: 'html5',
      backend: HTML5Backend,
      transition: {
        dragDropContext: {
          enableMouseEvents: true,
        },
      },
    },
    {
      id: 'touch',
      backend: TouchBackend,
      options: {
        enableMouseEvents: true,
        delayTouchStart: 200, // Small delay to distinguish between tap and drag
        ignoreContextMenu: true,
      },
      preview: true,
      transition: {
        type: 'touch',
      },
    },
  ],
};

// Client-side redirection script in case no www is used
if (window.location.hostname === 'songshake.com') {
  window.location.href = config.clientBaseUrl;
}

const container = document.getElementById('root');
const root = createRoot(container);

Modal.setAppElement(container);

root.render(
  <React.StrictMode>
    <DndProvider backend={MultiBackend} options={backendOptions}>
      <App />
    </DndProvider>
  </React.StrictMode>
);
